import Vue from 'vue';
import Loading from './components/loading.vue';
import Popup from './components/popup.vue';
import Notification from './components/notification.vue';
import Picker from './components/picker.vue';
import Options from './components/options';
import FullLoading from './components/full-loading.vue';

const root = document.createElement('div');
root.id = 'hlcx-base-ui-cont';

const picker = mount(Picker);
const popup = mount(Popup);
const notification = mount(Notification);
const loading = mount(Loading);
const c_options = mount(Options);
const fullLoading = mount(FullLoading);
document.body.appendChild(root);

function mount(component) {
  const el = root.appendChild(document.createElement('div'));

  return new Vue({
    el: el,
    data: {
      display: 'none',
      props: {}
    },
    render(h) {
      return h('div', {}, [
        this.display !== 'none' ? h(component, {
          props: { ...this.props }
        }) : null
      ]);
    }
  });
}

// picker
let pickerTimer = null;

function showPicker({
  ranges,
  rkey,
  value,
  force,
  onChange,
  onCancel,
  onTouchstart,
  onColumnChange
}) {
  clearTimeout(pickerTimer);

  const show = picker.props.show;
  picker.props = {
    show: show,
    ranges: ranges,
    rkey: rkey,
    value: value,
    force: force || [],
    onTouchstart: (column) => {
      onTouchstart && onTouchstart(column);
    },
    onColumnChange: (column, value) => {
      onColumnChange && onColumnChange(column, value);
    },
    callback: (key, value) => {
      hidePicker();
      if (key === 'confirm') {
        onChange && onChange(value);
      } else {
        onCancel && onCancel();
      }
    }
  };

  if (!show) {
    picker.display = '';
    pickerTimer = setTimeout(() => {
      picker.props.show = true;
    }, 50);
  }
}

function hidePicker() {
  clearTimeout(pickerTimer);
  picker.props.show = false;
  pickerTimer = setTimeout(() => {
    picker.display = 'none';
  }, 300);
}

// loading
let loadingTimer = null;

function showLoading({ title } = {}) {
  clearTimeout(loadingTimer);
  loading.display = '';
  loadingTimer = setTimeout(() => {
    loading.props = {
      show: true,
      title: title
    };
  }, 20);
}

function hideLoading() {
  clearTimeout(loadingTimer);
  loading.props.show = false;
  loadingTimer = setTimeout(() => {
    loading.display = 'none';
  }, 300);
}

// fullLoading
let fullLoadingTimer = null;
function showFullLoading({ title } = {}){
  clearTimeout(fullLoadingTimer);
  fullLoading.display = '';
  fullLoadingTimer = setTimeout(() => {
    fullLoading.props = {
      show: true,
      title: title
    };
  }, 20);
}

function hideFullLoading() {
  clearTimeout(fullLoadingTimer);
  fullLoading.props.show = false;
  fullLoadingTimer = setTimeout(() => {
    fullLoading.display = 'none';
  }, 300);
}

// popup
let popupTimer = null;

function showPopup(props) {
  clearTimeout(popupTimer);

  const show = popup.props.show;
  popup.props = {
    ...props,
    show: show,
    callback: res => {
      hidePopup();

      if (res === 'confirm') {
        props.confirm && props.confirm();
      } else if (res === 'cancel') {
        props.cancel && props.cancel();
      } else if (res === 'ignore') {
        props.ignore && props.ignore();
      }
    }
  };

  if (!show) {
    popup.display = '';
    popupTimer = setTimeout(() => {
      popup.props.show = true;
    }, 50);
  }
}

function hidePopup() {
  clearTimeout(popupTimer);
  popup.props.show = false;
  popupTimer = setTimeout(() => {
    popup.display = 'none';
  }, 300);
}

// options
let c_optionsTimer = null;

function showOptions(props) {
  clearTimeout(c_optionsTimer);

  const show = c_options.props.show;
  c_options.props = {
    ...props,
    show: show,
    onClickOverlay: () => {
      hideOptions();
    },
    onClickItem: index => {
      hideOptions();
      props.onClickItem && props.onClickItem(index);
    }
  };

  if (!show) {
    c_options.display = '';
    c_optionsTimer = setTimeout(() => {
      c_options.props.show = true;
    }, 50);
  }
}

function hideOptions() {
  clearTimeout(c_optionsTimer);
  c_options.props.show = false;
  c_optionsTimer = setTimeout(() => {
    c_options.display = 'none';
  }, 300);
}

// notification
let notificationTimer = null;
let notificationTimerAutoHide = null;

function showNotification({
  type,
  duration = 2000,
  message,
  showClose
}) {
  clearTimeout(notificationTimer);
  clearTimeout(notificationTimerAutoHide);

  const show = notification.props.show;
  notification.props = {
    type,
    duration,
    message,
    showClose,
    show,
    onClose: hideNotification
  };

  if (!show) {
    notification.display = '';
    notificationTimer = setTimeout(() => {
      notification.props.show = true;
    }, 50);
  }

  if (duration > 0) {
    notificationTimerAutoHide = setTimeout(() => {
      hideNotification();
    }, duration);
  }
}

function hideNotification() {
  clearTimeout(notificationTimer);
  clearTimeout(notificationTimerAutoHide);
  notification.props.show = false;
  notificationTimer = setTimeout(() => {
    notification.display = 'none';
  }, 300);
}

export {
  showPicker,
  hidePicker,
  showLoading,
  hideLoading,
  showPopup,
  hidePopup,
  showNotification,
  hideNotification,
  showOptions,
  hideOptions,
  showFullLoading,
  hideFullLoading
};



// WEBPACK FOOTER //
// ./src/ui/base/index.js